import { useMemo } from "react"

type UseChartDensityProps = {
  datasets: { data: unknown[] }[]
  showLabels?: boolean
  maxBarsForDefaultLabels?: number
}

/**
 * Generic chart density hook that can be reused across different chart components.
 * It centralizes label-density decisions to keep chart components simpler and more readable.
 */
export const useChartDensity = ({
  datasets,
  showLabels,
  maxBarsForDefaultLabels = 100,
}: UseChartDensityProps): {
  barsCount: number
  defaultShowLabels: boolean
  shouldShowLabels: boolean
} => {
  const barsCount = useMemo(
    () => datasets.reduce((sum, dataset) => sum + dataset.data.length, 0),
    [datasets],
  )

  const defaultShowLabels = barsCount <= maxBarsForDefaultLabels
  const shouldShowLabels = showLabels ?? defaultShowLabels

  return {
    barsCount,
    defaultShowLabels,
    shouldShowLabels,
  }
}
